"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorFactory = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var factory_1 = require("../internal/factory");
var units_1 = require("../internal/units");
var unitToStyle_1 = require("../internal/unitToStyle");
var stateSettings = {
    palette: {
        type: 'Object',
        required: false,
        properties: {
            text: units_1.UNITS.COLOR.asOptional(),
            background: units_1.UNITS.COLOR.asOptional(),
            border: units_1.UNITS.COLOR.asOptional()
        }
    }
};
exports.AnchorFactory = factory_1.factory({
    name: 'Anchor',
    settings: {
        font: units_1.UNITS.FONT,
        width: units_1.UNITS.MEASURE.asOptional(),
        height: units_1.UNITS.MEASURE.asOptional(),
        border: units_1.UNITS.BORDER.asOptional(),
        shadow: units_1.UNITS.SHADOW.asOptional(),
        padding: units_1.UNITS.PADDING.asOptional(),
        palette: {
            type: 'Object',
            properties: {
                text: units_1.UNITS.COLOR,
                background: units_1.UNITS.COLOR.asOptional(),
                border: units_1.UNITS.COLOR.asOptional()
            }
        }
    },
    $when: {
        visited: stateSettings,
        hover: stateSettings,
        active: stateSettings,
        link: stateSettings,
        nolink: stateSettings,
        focus: stateSettings
    },
    component: function (_a) {
        var settings = _a.settings, $when = _a.$when;
        var stateToStyle = function (state) {
            var _a, _b, _c;
            return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        ", "\n        ", "\n        ", "\n      "], ["\n        ", "\n        ", "\n        ", "\n      "])), unitToStyle_1.ifDefined('color', (_a = state === null || state === void 0 ? void 0 : state.palette) === null || _a === void 0 ? void 0 : _a.text), unitToStyle_1.ifDefined('background-color', (_b = state === null || state === void 0 ? void 0 : state.palette) === null || _b === void 0 ? void 0 : _b.background), unitToStyle_1.ifDefined('border-color', (_c = state === null || state === void 0 ? void 0 : state.palette) === null || _c === void 0 ? void 0 : _c.border));
        };
        return styled_components_1.default.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      /* Remove default browser a tag styling */\n      text-decoration: none;\n\n      /* Show a pointer on hover */\n      cursor: pointer;\n\n      /* Flex items inside */\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n\n      /* Anchor is a non-growing flex item */\n      flex-grow: 0;\n      flex-basis: content;\n\n      /* Add font styles */\n      ", "\n      \n      /* Add padding and border if defined */\n      ", "\n      ", "\n      ", "\n\n      /* Style using palette in 'default' state */\n      ", "\n\n      /* Style each state */\n      &:link {\n        ", "\n      }\n\n      &:visited {\n        ", "\n      }\n\n      &:hover {\n        ", "\n      }\n\n      &:focus {\n        ", "\n      }\n\n      &:active {\n        ", "\n      }\n\n      &:not([href]) {\n        ", "\n      }\n    "], ["\n      /* Remove default browser a tag styling */\n      text-decoration: none;\n\n      /* Show a pointer on hover */\n      cursor: pointer;\n\n      /* Flex items inside */\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n\n      /* Anchor is a non-growing flex item */\n      flex-grow: 0;\n      flex-basis: content;\n\n      /* Add font styles */\n      ", "\n      \n      /* Add padding and border if defined */\n      ", "\n      ", "\n      ", "\n\n      /* Style using palette in 'default' state */\n      ", "\n\n      /* Style each state */\n      &:link {\n        ", "\n      }\n\n      &:visited {\n        ", "\n      }\n\n      &:hover {\n        ", "\n      }\n\n      &:focus {\n        ", "\n      }\n\n      &:active {\n        ", "\n      }\n\n      &:not([href]) {\n        ", "\n      }\n    "])), unitToStyle_1.fontToStyle(settings.font), settings.padding !== undefined ? unitToStyle_1.paddingToStyle(settings.padding) : '', settings.border !== undefined ? unitToStyle_1.borderToStyle(settings.border) : '', settings.shadow !== undefined ? unitToStyle_1.shadowToStyle(settings.shadow) : '', stateToStyle({ palette: settings.palette }), stateToStyle($when.link), stateToStyle($when.visited), stateToStyle($when.hover), stateToStyle($when.focus), stateToStyle($when.active), stateToStyle($when.nolink));
    }
});
var templateObject_1, templateObject_2;
